import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']

  ultimosComentariosClick () {
    const blog_id = this.contentTarget.dataset.blogId
    const loadingText = 'Cargando comentarios'
    document.body.dataset.loading = loadingText

    fetch(`/ajax/blog/${blog_id}/ultimos_comentarios`)
      .then(response => response.text())
      .then(responseText => {
        this.contentTarget.insertAdjacentHTML('beforeend', responseText)
        delete document.body.dataset.loading
      })
  }
}
